import React from "react";
import ModalJSXElement from "../helpers/modal";
import SimManager from "./simManager";

type modalObject = {
  modal: ModalJSXElement;
  name: string;
  showing: boolean;
};

class ModalManager {
  private static instance: ModalManager;
  private modals: modalObject[];
  // eslint-disable-next-line
  private modalJS: JSX.Element;

  private constructor() {
    this.modals = [];
    this.modalJS = <></>;
  }

  public static getInstance() {
    if (!this.instance) this.instance = new ModalManager();
    return this.instance;
  }

  public static openModal(scope: string, modal?: string) {
    if (modal && ModalManager.getInstance().openModal(modal))
      SimManager.getInstance().openModal(modal, scope);
  }

  registerModal(modal: ModalJSXElement, name: string) {
    const modalElem = {
      modal: modal,
      name: name,
      showing: false,
    };

    if (modalElem) {
      this.modals.push(modalElem);
      return true;
    } else return false;
  }

  addModal(): boolean {
    // let modalObj = this.createModal(modalName);
    // let modal = {
    //     modal: modalObj.modal,
    //     name: modalName,
    //     showing: true,
    //     childRef: modalObj.childRef,
    // };

    // if (modal) {
    //     this.modals.push(modal);
    //     return true;
    // } else return false;
    return false;
  }

  openModal(modalName: string, callback?: () => void, modalData?: any) {
    const modal = this.modals.filter((item) => item.name == modalName);
    if (modal.length > 0) {
      modal[0].showing = true;
      modal[0].modal.openModal(callback, modalData);
      return true;
    } else return false;
  }

  closedModal(modelData: unknown): void {
    const showingModal = this.modals.find(
      (m) => m.modal.state.modalOpen === true
    );
    SimManager.getInstance().closedModal(showingModal?.name, modelData);
  }

  // eslint-disable-next-line
  getCurrentModal(): JSX.Element {
    // const modal = this.modals.filter((item) => item.showing == true);

    // if (modal.length > 0) {
    //     return modal[0].modal;
    // } else
    return <></>;
  }

  createModal(modalName: string): {
    // eslint-disable-next-line
    modal: JSX.Element;
    childRef: React.RefObject<ModalJSXElement>;
  } {
    const ref: React.RefObject<ModalJSXElement> = React.createRef();
    const modal = (
      <ModalJSXElement key={modalName} ref={ref} modal={modalName} />
    );
    return { modal: modal, childRef: ref };
  }

  //add functions to open and close specific modals
}

export default ModalManager;
